<template>
  <form ref="withdrawForm" @submit.prevent="() => false">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <label :style="withdrawalDateRemarks && 'margin-bottom:0px;'">Withdrawal Date</label>
        <span v-if="withdrawalDateRemarks" class="mb-2 d-block">{{ withdrawalDateRemarks }}</span>
        <input v-if="disableDate" type="text" class="form-control" v-model="readonlyDate" readonly disabled />
        <el-date-picker
          v-model="date"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
          type="date"
          v-else
          @change="$emit('handleWithdrawalDateChange')"
          placeholder="Pick a day"
          :disabled="readonly"
        ></el-date-picker>
      </div>
      <!--Main Reason-->
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <label :style="withdrawalDateRemarks && 'margin-bottom:30px;'">Main Reason</label>
        <select v-model="mainReason" class="form-control pro-edt-select form-control-primary" :disabled="readonly" @change="resetField($event)">
          <option v-for="item in mainReasonList" :key="item">{{ item }}</option>
        </select>
      </div>

      <!--Reason-->
      <div class="col-lg-12" v-if="showNotSuitedReason">
        <label>Could you share why?</label>
        <select v-model="reason1" class="form-control pro-edt-select form-control-primary" required :disabled="readonly">
          <option v-for="item in notSuitedReasonList">{{ item }}</option>
        </select>
        <input v-if="reason1 === 'Others'" type="text" class="form-control" v-model="reason1Text" required :readonly="readonly" />
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showCountryInput">
        <label>Could you share why?</label>
        <input type="text" class="form-control" v-model="reason1" required :readonly="readonly" />
      </div>

      <!--To Country-->
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showCountryInput">
        <label>Country Name</label>
        <select v-model="CountryName" class="form-control pro-edt-select form-control-primary" required :disabled="readonly">
          <option v-for="item in countryList()" :key="item">{{ item }}</option>
        </select>
      </div>

      <!--School Destination-->
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="['The school is not suited for my child', 'Graduation'].includes(this.mainReason)">
        <label>Destination School</label>
        <select v-model="schoolType" class="form-control pro-edt-select form-control-primary" required :disabled="readonly">
          <option v-for="item in schoolTypeList" :key="item">{{ item }}</option>
        </select>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showSchoolSelect">
        <label>School Name</label>
        <select v-model="school" class="form-control pro-edt-select form-control-primary" required :disabled="readonly">
          <option v-for="item in schoolList">{{ item }}</option>
        </select>
        <input v-if="school === 'Other'" type="text" class="form-control" v-model="schoolText" required :readonly="readonly" />
      </div>
      <!--      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showSchoolNameInput">-->
      <!--        <label>School Name</label>-->
      <!--        <input type="text" class="form-control" required v-model="schoolText" :readonly="readonly"/>-->
      <!--      </div>-->

      <!--Remarks-->
      <!--      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showOptionalRemarks">-->
      <!--        <label>Remarks (Optional)</label>-->
      <!--        <input type="text" class="form-control" v-model="reason1Text" :readonly="readonly"/>-->
      <!--      </div>-->

      <!--      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showReasonsSelect">-->
      <!--        <label>Reason 1</label>-->
      <!--        <select v-model="reason1" class="form-control pro-edt-select form-control-primary" required-->
      <!--                :disabled="readonly">-->
      <!--          <option v-for="item in reason1List">{{ item }}</option>-->
      <!--        </select>-->
      <!--        <input v-if="reason1 === 'Others'" type="text" class="form-control" v-model="reason1Text" required-->
      <!--               placeholder="Please indicate reason"-->
      <!--               :readonly="readonly"/>-->
      <!--      </div>-->
      <!--      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showReasonsSelect">-->
      <!--        <label>Reason 2</label>-->
      <!--        <select v-model="reason2" class="form-control pro-edt-select form-control-primary" :disabled="readonly">-->
      <!--          <option v-for="item in reason2List">{{ item }}</option>-->
      <!--        </select>-->
      <!--        <input v-if="reason2 === 'Others'" type="text" class="form-control" v-model="reason2Text"-->
      <!--               placeholder="Please indicate reason"-->
      <!--               :readonly="readonly"/>-->
      <!--      </div>-->
      <!--      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="showReasonsSelect">-->
      <!--        <label>Reason 3</label>-->
      <!--        <select v-model="reason3" class="form-control pro-edt-select form-control-primary" :disabled="readonly">-->
      <!--          <option v-for="item in reason3List">{{ item }}</option>-->
      <!--        </select>-->
      <!--        <input v-if="reason3 === 'Others'" type="text" class="form-control" v-model="reason3Text"-->
      <!--               placeholder="Please indicate reason"-->
      <!--               :readonly="readonly"/>-->
      <!--      </div>-->

      <!--To Country-->
      <div class="col-lg-12">
        <label>Is there anything we can do to improve?</label>
        <textarea class="form-control" v-model="Improvement" :readonly="readonly"></textarea>
      </div>
    </div>

    <div class="row custom-modal-footer" style="padding: 20px 0 10px; background: none" v-if="!isHideButton">
      <div class="col-lg-6">
        <button @click="$emit('close')" class="btn btn-secondary float-left">Cancel</button>
      </div>
      <div class="col-lg-6">
        <button @click="submit()" class="btn btn-primary float-right btnFamilyIDSearch">Withdraw</button>
      </div>
    </div>
  </form>
</template>

<script>
import { countryList, notSuitedSchoolList, schoolList, schoolListMIS, schoolListWithoutUndeclared } from './withdrawReason'
import { getFormatDate } from '@/helper/utily'

export default {
  name: 'OnlineStudentWithdrawForm',
  props: ['isHideButton', 'readonly', 'passData', 'withdrawalDateRemarks', 'withdrawReasonList', 'disableDate'],
  data() {
    return {
      date: null,
      readonlyDate: null,
      mainReason: '',
      school: '',
      schoolType: '',
      schoolText: '',
      reason1: '',
      reason1Text: '',
      // reason2: "",
      // reason2Text: "",
      // reason3: "",
      // reason3Text: "",
      notSuitedReason: '',
      notSuitedText: '',
      CountryName: '',
      Improvement: '',
    }
  },
  watch: {
    date(val) {
      this.$emit('date', val)
    },
    mainReason(val) {
      this.$emit('main-reason', val)
    },
    school(val) {
      this.$emit('school', val)
    },
    schoolText(val) {
      this.$emit('schoolText', val)
    },
    schoolType(val) {
      console.log(val, 'schooltype')
      this.$emit('SchoolType', val)
    },
    reason1(val) {
      this.$emit('reason1', val)
    },
    reason1Text(val) {
      this.$emit('reason1Text', val)
    },
    // reason2(val) {
    //   this.$emit("reason2", val);
    // },
    // reason2Text(val) {
    //   this.$emit("reason2Text", val);
    // },
    // reason3(val) {
    //   this.$emit("reason3", val);
    // },
    // reason3Text(val) {
    //   this.$emit("reason3Text", val);
    // },
    CountryName(val) {
      this.$emit('CountryName', val)
    },
    Improvement(val) {
      this.$emit('Improvement', val)
    },
  },
  mounted() {
    this.mainReason = this.passData?.MainReason
    this.date = getFormatDate(this.passData?.Date, 'DD/MM/YYYY')
    this.readonlyDate = getFormatDate(this.passData?.Date)
    this.reason1 = this.passData?.Reason1
    // this.reason2 = this.passData?.Reason2;
    // this.reason3 = this.passData?.Reason3;
    this.reason1Text = this.passData?.Reason1Text
    // this.reason2Text = this.passData?.Reason2Text;
    // this.reason3Text = this.passData?.Reason3Text;
    this.school = this.passData?.School
    this.schoolText = this.passData?.schoolText
    this.CountryName = this.passData?.CountryName
    this.Improvement = this.passData?.Improvement
    this.schoolType = this.passData?.SchoolType
  },
  computed: {
    showSchoolSelect() {
      return [
        // "Enrolling in another local/international Pre-School",
        // "Enrolling in another international Primary",
        // "Enrolling in another international Secondary",
        // "Withdrawing from EtonHouse campus and enrolling to Middleton International School",
        'The school is not suited for my child',
        'Graduation',
      ].includes(this.mainReason)
    },
    // showSchoolNameInput() {
    //   return ["Enrolling to a local Primary"].includes(this.mainReason);
    // },
    // showOptionalRemarks() {
    //   return [
    //     "Moving to another location in Singapore",
    //   ].includes(this.mainReason);
    // },
    showCountryInput() {
      return ['Repatriating to home country', 'Relocation to another country'].includes(this.mainReason)
    },
    // showReasonsSelect() {
    //   return [
    //     "Enrolling in another local/international Pre-School",
    //     "Enrolling in another international Primary",
    //     "Enrolling in another international Secondary"
    //   ].includes(this.mainReason);
    // },
    showNotSuitedReason() {
      return ['The school is not suited for my child'].includes(this.mainReason)
    },
    notSuitedReasonList() {
      return ['Leadership', 'Inclusive ed', 'Facilities', 'Staff', 'EAL support', 'Curriculum', 'Others']
    },
    mainReasonList() {
      return [
        // "Enrolling in another local/international Pre-School",
        // "Enrolling in another international Primary",
        // "Enrolling in another international Secondary",
        // "Enrolling to a local Primary",
        'Repatriating to home country',
        'Relocation to another country',
        // "Withdrawing from EtonHouse campus and enrolling to Middleton International School",
        // "Moving to another location in Singapore",
        'The school is not suited for my child',
        'Graduation',
      ]
    },
    // subReasonList() {
    //   if (this.withdrawReasonList) {
    //     return this.withdrawReasonList;
    //   } else {
    //     return [
    //       `Curriclum: Not academic enough`,
    //       `Curriclum: Too Academic`,
    //       `Curriclum: Quality of the teaching and learning`,
    //       `Curriclum: Quality and Frequency of assessments and feedback`,
    //       `Curriclum: Not enough sports in timetable`,
    //       `Curriclum: Preparation for Primary School`,
    //       `Curriclum: Unable to provide learning support`,
    //       `Facilities: Not enough Sports`,
    //       `Facilities: Not enough outdoor space`,
    //       `Facilities: Not enough communal spaces (library, auditorium, dining)`,
    //       `Facilities: Not enough IT resources`,
    //       `Fees: Increased too much`,
    //       `Fees: Change in financial situation`,
    //       `Fees: Looking for cheaper school`,
    //       `Language: Want more Language learning time`,
    //       `Language: Not happy with language acquisition`,
    //       `Language: More options`,
    //       `Logistics: Need longer School hours`,
    //       `Logistics: No bus service`,
    //       `Logistics: Not a good selection of After school Activities`,
    //       `Logistics: Too many holidays in Academic Year`,
    //       `Logistics: No Childcare options`,
    //       `School Community: Not diverse enough`,
    //       `School Community: Not inclusive enough`,
    //       `School Community: Not enough Community feel`,
    //       `School philosophy: Disagree with Behavior guidance policies`,
    //       `School philosophy: Disagree with Classroom management`,
    //       `Staff: Issue with Staff Member`,
    //       `Staff: High Turnover`,
    //       `Other: School Transition: Need to secure place in Primary`,
    //       `Other: School Transition: Need to secure place in Secondary`,
    //       `Other: Parent did not disclose`,
    //       `Others`
    //     ];
    //   }
    // },
    schoolTypeList() {
      if (this.mainReason === 'Graduation') {
        return ['Pre-School', 'International School', 'Local School']
      } else {
        return ['Pre-School', 'International School']
      }
    },
    schoolList() {
      return notSuitedSchoolList
      // if (["Withdrawing from EtonHouse campus and enrolling to Middleton International School"].includes(this.mainReason)) {
      //   return schoolListMIS;
      // } else if([
      //   "Enrolling in another local/international Pre-School",
      //   "Enrolling in another international Primary",
      //   "Enrolling in another international Secondary",
      // ].includes(this.mainReason)){
      //   return schoolListWithoutUndeclared;
      // } else
      //   if (["The school is not suited for my child",].includes(this.mainReason)) {
      //   return notSuitedSchoolList;
      // } else {
      //   return schoolList;
      // }
    },
    // reason1List() {
    //   return this.subReasonList.filter(r => r === "Others" || ![this.reason2, this.reason3].includes(r));
    // },
    // reason2List() {
    //   return this.subReasonList.filter(r => r === "Others" || ![this.reason1, this.reason3].includes(r));
    // },
    // reason3List() {
    //   return this.subReasonList.filter(r => r === "Others" || ![this.reason1, this.reason2].includes(r));
    // }
  },
  methods: {
    countryList() {
      return countryList
    },
    resetField() {
      this.reason1Text = ''
      this.reason1 = ''
    },
    submit() {
      if (this.$refs.withdrawForm.reportValidity()) {
        this.$emit('submit')
      }
      return false
    },
  },
}
</script>
